import { Base } from '../../abstract/base.model';
import { isRecord } from '../utils/is-record';
import { dateOrNull, nullableBoolean, nullableNumber, nullableString } from '../utils/wire-value-utils';
import { DroneOwnership } from './drone-ownership.model';
import { DroneReportScope } from './drone-report-scope.model';
import { DroneReportStatus } from './drone-report-status.model';

/**
 * A drone incident-history report, built from the hub's `/admin/drone-reports` JSON (hub
 * `data-models/drone-report.ts`). Read-only in admin: reports change only through the generate, regenerate,
 * retry and delete actions. Fields the hub didn't send stay `undefined`.
 */
export class DroneReport extends Base {
  organizationId?: string | null;
  droneId?: string | null;
  droneSource?: DroneOwnership | null;
  name?: string | null;
  scope?: DroneReportScope | null;
  sprayRecordId?: string | null;
  status?: DroneReportStatus | null;
  /** Calendar dates ('YYYY-MM-DD') as sent by the hub. */
  startDate?: string | null;
  endDate?: string | null;
  generatedByAdmin?: boolean | null;
  /** 0 to 100. */
  generationProgress?: number | null;
  recordCount?: number | null;
  fileSize?: string | null;
  reportUrl?: string | null;
  /** Pre-signed S3 URL, only on GET /admin/drone-reports/:id for a ready report. */
  downloadUrl?: string | null;
  completedAt: Date | null;
  errorMessage?: string | null;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.organizationId = nullableString(source['organizationId']);
    this.droneId = nullableString(source['droneId']);
    this.droneSource = nullableString(source['droneSource']) as DroneOwnership | null | undefined;
    this.name = nullableString(source['name']);
    this.scope = nullableString(source['scope']) as DroneReportScope | null | undefined;
    this.sprayRecordId = nullableString(source['sprayRecordId']);
    this.status = nullableString(source['status']) as DroneReportStatus | null | undefined;
    this.startDate = nullableString(source['startDate']);
    this.endDate = nullableString(source['endDate']);
    this.generatedByAdmin = nullableBoolean(source['generatedByAdmin']);
    this.generationProgress = nullableNumber(source['generationProgress']);
    this.recordCount = nullableNumber(source['recordCount']);
    this.fileSize = nullableString(source['fileSize']);
    this.reportUrl = nullableString(source['reportUrl']);
    this.downloadUrl = nullableString(source['downloadUrl']);
    this.completedAt = dateOrNull(source['completedAt']);
    this.errorMessage = nullableString(source['errorMessage']);
  }
}
